import { makeStyles } from '@material-ui/core/styles';
import { MOBILE_BREAKPOINT } from '../../config/constants';

export const useStyles = makeStyles(theme => ({
    loader: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    page: {
        flex: 1,
    },
    pageContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    container: {
        flex: 1,
        justifyContent: 'center',
        alignSelf: 'center',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            width: '100%',
            maxWidth: '100%',
            marginTop: '0',
        },
        [theme.breakpoints.between('lg', 'xl')]: {
            maxWidth: 1300,
            marginTop: '2rem',
        },
        [theme.breakpoints.up('xl')]: {
            maxWidth: 1500,
            marginTop: '3rem',
        },
    },
    mobilePreviewContainer: {
        marginTop: '1.5rem',
    },
    dateAndCategory: {
        padding: '0.5rem',
        borderRadius: '0.375rem',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            margin: '0.5rem',
            width: 'calc(100% - 1rem)',
        },
    },
    middleColumn: {
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            paddingLeft: '1rem',
            paddingRight: '1rem',
        },
        [theme.breakpoints.between(MOBILE_BREAKPOINT, 'md')]: {
            paddingLeft: '2rem',
            paddingRight: '2rem',
        },
        [theme.breakpoints.up('lg')]: {
            paddingRight: '4rem',
        },
        [theme.breakpoints.up('xl')]: {
            paddingRight: '8rem',
        },
    },

    rightSideColumn: {
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            paddingLeft: '2rem',
            paddingRight: '2rem',
        },
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            paddingLeft: '1rem',
            paddingRight: '1rem',
        },
    },
    sectionTitle: {
        fontSize: '20px',
        fontWeight: 400,
        marginBottom: 0,
    },
    eventDescription: {
        fontSize: '16px',
        marginTop: '5px',
        fontWeight: 400,
    },
    language: {
        display: 'flex',
        flexDirection: 'row',
        gap: '5px',
        alignItems: 'center',
        marginRight: '10px',
        marginTop: '8px',
        fontWeight: 400,
        color: theme.palette.secondary.main,
    },
    languageImage: {
        height: '30px',
    },
    tag: {
        color: 'black',
        cursor: 'pointer',
        borderRadius: '20px',
        border: '1px solid black',
        padding: '6px 15px',
        display: 'inline-block',
        fontWeight: 500,
        marginTop: '16px',
        marginRight: '16px',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            transform: 'scale(1.05)',
        },
    },
    eventDetails: {
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            paddingBottom: '2rem',
        },
    },
}));
